import { number, object, string } from "yup"
import { ID2 } from "./yup.common"

export default object({
  orderId: ID2("Order").required("Please select a valid order!"),
  amount: number()
    .positive("Payment amount should be positive!")
    .required("Please enter a valid amount!"),
  referenceId: string(),
  status: string().required("Please select a valid transaction status"),
  paymentMethod: string().required("Please select a valid payment method!"),
})
